// utils/hashPassword.js
export async function hashPassword(password) {
  const encoder = new TextEncoder(); // ✅ encodes in UTF-8
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}
